import type { UsageUserOption } from './Context'
import { UserSelect } from '@ztechapps/webui.input'
import { useUsageListContext } from './Context'

// Narrows the table to one user's rows through the stored `createdBy` id. `UserSelect` defaults to
// active users only, which would hide a departed user who still has usage rows, so the status
// default is overridden to every user.
export const UserFilter = () => {
  const { userFilter, setUserFilter } = useUsageListContext()

  return (
    <div style={{ minWidth: 260 }}>
      <UserSelect
        inputId="aiUsageUserFilter"
        placeholder="Filter by user"
        aria-label="Filter by user"
        isClearable
        filter={{ status: { $exists: true } }}
        value={userFilter}
        onChange={(option) => setUserFilter(option as UsageUserOption | null)}
      />
    </div>
  )
}
